import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GlobalLoaderService {

  public loaderStatus = new BehaviorSubject<number>(0);

  private ignoreOnceList = [];

  constructor() { }

  public triggerAuto(): void {
    const current = this.loaderStatus.getValue();
    const next = current + 1;
    this.loaderStatus.next(next);
  }

  public completeAuto(): void {
    const current = this.loaderStatus.getValue();
    let next = current - 1;

    // Making sure it never goes below zero.
    if (next < 0) {
      next = 0;
    }

    // console.log('Cleared to the loader queue!', next);
    this.loaderStatus.next(next);
  }

  /**
   * Drops the count to zero, for the one case where requests are abandoned rather than
   * answered: a revoked session on its way to /logout. The interceptor counts a request back
   * out in a finalize, and a response that is never delivered reaches no finalize, so without
   * this the overlay stays up over the login page until a manual refresh (Bug 47900).
   *
   * Safe to call with other work still in flight. completeAuto clamps at zero, so the strays
   * that do arrive afterwards cannot drive it negative and swallow a later spinner.
   */
  public reset(): void {
    this.loaderStatus.next(0);
  }

  public ignoreOnce(url: string): void {
    this.ignoreOnceList.push(url);
  }

  public cleanupIgnoreOnce(url: string): void {
    this.ignoreOnceList = this.ignoreOnceList.filter(eIgnoreUrl => eIgnoreUrl !== url);
  }

  public hasIgnoreOnce(url: string): boolean {
    return !!this.ignoreOnceList.find(ignore => ignore === url);
  }
}
